module.exports = __webpack_public_path__ + "static/img/action-icon2.062e8901.png";